"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const design_system_1 = require("@zapier/design-system");
const common_components_1 = require("@zapier/common-components");
const common_utils_1 = require("@zapier/common-utils");
const Styles = common_utils_1.labelStyles(__filename, {
    root: () => [
        {
            position: 'relative',
        },
    ],
});
const FloatingMenu = ({ children, onClickOutside, onClose, onFocus, }) => {
    return (common_utils_1.isolateComponent(common_components_1.Keydown, { handlers: { escape: onClose || onClickOutside } },
        common_utils_1.isolateComponent("div", { css: Styles.root(), onFocus: onFocus, role: "presentation" },
            common_utils_1.isolateComponent(design_system_1.FloatingBox, { align: "stretch", minWidth: "400px", onClickOutside: onClickOutside, position: "south" }, children))));
};
exports.default = FloatingMenu;
